import { Link } from "react-router-dom";
export default function RelatedInfographics({ items = [], currentSlug }) {
  const related = items.filter((item) => item.slug !== currentSlug).slice(0, 4);
  return (
    <section className="soft-card p-6 sm:p-8">
      <h2 className="text-2xl font-black text-neutral-950">Related humanoid infographics</h2>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        {related.map((item) => <Link key={item.slug} to={item.path} className="rounded-2xl border border-neutral-200 bg-neutral-50 p-4 font-bold text-neutral-950 transition hover:border-blue-300 hover:text-blue-700">{item.title}</Link>)}
      </div>
    </section>
  );
}
